import { createEffect } from 'effector';
import { api } from '../../api/axiosInstance.js';

export const getUsersLogFx = createEffect().use(async (query) => {
  return (
    await api().get(
      `/audit-events/${typeof query === 'string' ? `?${query}` : ''}`
    )
  ).data;
});

export const getUsersListFx = createEffect().use(async (query) => {
  return (
    await api().get(`/users/${typeof query === 'string' ? `?${query}` : ''}`)
  ).data;
});

export const blockUserFx = createEffect().use(async ({ uId, block_reason }) => {
  return (
    await api().post(`/users/block-user/${uId}?block_reason=${block_reason}`)
  ).data;
});

export const unblockUserFx = createEffect().use(async (id) => {
  return (await api().post(`/users/unblock-user/${id}`)).data;
});

export const getUserLoginHistoryFx = createEffect().use(
  async () => (await api().get('/audit-events/user-login-history')).data
);

export const getAdminLoginHistoryFx = createEffect().use(async (query) => {
  return (await api().get(`/audit-events/admin-login-history?${query}`)).data;
});

export const changeUserPasswordByAdminFx = createEffect().use(
  async ({ uId, new_password }) =>
    (await api().post(`/users/change-user-password/${uId}`, { new_password }))
      .data
);

export const createUserByAdminFx = createEffect().use(
  async (values) => (await api().post(`/users/crete_by_admin`, values)).data
);
